var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "validator",
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var valid = ref.valid
            return [
              _c(
                "b-form",
                {
                  class: [_vm.inline ? "gap-2 items-center" : ""],
                  attrs: { inline: _vm.inline },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    },
                    reset: function($event) {
                      $event.preventDefault()
                      return _vm.clear($event)
                    }
                  }
                },
                [
                  _c("validation-provider", {
                    staticClass: "flex-grow",
                    attrs: { name: "name", rules: "required", slim: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : ""
                                  ],
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Nome:",
                                    "label-for": "list-name"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "pr-0 w-full",
                                    attrs: {
                                      id: "list-name",
                                      type: "text",
                                      state: _vm.getValidationState(
                                        validationContext
                                      )
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name"
                                    }
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      class: [
                                        {
                                          absolute: _vm.inline
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c("validation-provider", {
                    staticClass: "flex-grow",
                    attrs: { name: "email", rules: "email|required", slim: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : ""
                                  ],
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Email:",
                                    "label-for": "contact-email"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "pr-0 w-full",
                                    attrs: {
                                      id: "contact-email",
                                      type: "email",
                                      state: _vm.getValidationState(
                                        validationContext
                                      )
                                    },
                                    model: {
                                      value: _vm.email,
                                      callback: function($$v) {
                                        _vm.email = $$v
                                      },
                                      expression: "email"
                                    }
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      class: [
                                        {
                                          absolute: _vm.inline
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c("validation-provider", {
                    staticClass: "flex-grow",
                    attrs: { name: "phone", slim: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : ""
                                  ],
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Fone:",
                                    "label-for": "phone"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "pr-0 w-full",
                                    attrs: {
                                      id: "phone",
                                      state: _vm.getValidationState(
                                        validationContext
                                      )
                                    },
                                    model: {
                                      value: _vm.phone,
                                      callback: function($$v) {
                                        _vm.phone = $$v
                                      },
                                      expression: "phone"
                                    }
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      class: [
                                        {
                                          absolute: _vm.inline
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  (_vm.showSubmit || _vm.showReset) && !_vm.inlineInput
                    ? [
                        !_vm.compact
                          ? _c(
                              "b-form-row",
                              {
                                class: [
                                  "justify-end",
                                  _vm.inline ? "ml-auto" : ""
                                ]
                              },
                              [
                                _vm.showSubmit
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _vm._t(
                                          "submit-button",
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  disabled: !valid,
                                                  type: "submit",
                                                  variant: "primary"
                                                }
                                              },
                                              [
                                                _vm._t("submit-button-text", [
                                                  _vm._v("Salvar")
                                                ])
                                              ],
                                              2
                                            )
                                          ],
                                          { valid: valid }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm.showReset
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _vm._t("reset-button", [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                type: "reset",
                                                variant: "outline-secondary"
                                              }
                                            },
                                            [
                                              _vm._t("reset-button-text", [
                                                _vm._v("Limpar")
                                              ])
                                            ],
                                            2
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "b-form-group",
                              { staticClass: "flex-grow flex justify-end" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex gap-2" },
                                  [
                                    _vm._t(
                                      "submit-button",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              disabled: !valid,
                                              type: "submit",
                                              variant: "primary"
                                            }
                                          },
                                          [
                                            _vm._t("submit-button-text", [
                                              _vm._v("Salvar")
                                            ])
                                          ],
                                          2
                                        )
                                      ],
                                      { valid: valid }
                                    ),
                                    _vm._t("reset-button", [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "reset",
                                            variant: "outline-secondary"
                                          }
                                        },
                                        [
                                          _vm._t("reset-button-text", [
                                            _vm._v("Limpar")
                                          ])
                                        ],
                                        2
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ]
                            )
                      ]
                    : _vm._e(),
                  _vm.inlineInput
                    ? _c(
                        "b-input-group",
                        [
                          _c(
                            "b-input-group-append",
                            [
                              _vm._t("search-button", [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "outline-primary" },
                                    on: { click: _vm.search }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "SearchIcon" }
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "align-middle" },
                                      [_vm._v("Buscar")]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "submit",
                                    variant: "outline-primary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "PlusIcon" }
                                  }),
                                  _c("span", { staticClass: "align-middle" }, [
                                    _vm._v("Incluir")
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "reset",
                                    variant: "outline-primary"
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "XIcon" }
                                  }),
                                  _c("span", { staticClass: "align-middle" }, [
                                    _vm._v("Limpar")
                                  ])
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }